@if (loadingBarService.value$ | async) {
  <mat-progress-bar mode="indeterminate" class="progess-bar" />
}

<main #container class="wrapper">
  <div class="content">
    <router-outlet />
  </div>
</main>

<adm-sprite />

<wzb-notifications />
